// import PropTypes from 'prop-types'
import { Swiper, SwiperSlide } from 'swiper/react'
import NextImage from 'next/image'
import Fade from 'react-reveal/Fade'

import { Root } from './ImageCarousel.style'

import 'swiper/css'

const ImageCarousel = ({ images }) => {
  if (!images) return null

  return (
    <Fade right distance="50px" duration={1500}>
      <Root>
        <Swiper
          spaceBetween={20}
          slidesPerView={1}
          centeredSlidesBounds
          centerInsufficientSlides
          breakpoints={{
            600: {
              slidesPerView: 2,
            },
            800: {
              slidesPerView: 3,
            },
          }}
        >
          {images.map((image, index) => (
            <SwiperSlide key={index}>
              <NextImage
                src={image}
                alt=""
                sizes="(min-width: 800px) 33.33vw, (min-width: 600px) 50vw, 100vw"
                lazyBoundary="500px"
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </Root>
    </Fade>
  )
}

ImageCarousel.propTypes = {}

ImageCarousel.defaultProps = {}

export default ImageCarousel
